export const APPLINK_MISSING = 'APPLINK_MISSING' as const;
export const APPLINK_REQ_AUTH = 'APPLINK_REQ_AUTH' as const;
export const REMOTE_SERVER_ERROR = 'REMOTE_SERVER' as const;
export const REMOTE_LINK_MISSING = 'REMOTE_LINK_MISSING' as const;
